var _style, _line, _polyline, _polyline2, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360.1 243.4",
    style: {
      enableBackground: "new 0 0 360.1 243.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B3B3B3;}\r\n\t.st1{fill:#C2000B;}\r\n\t.st2{fill:#545051;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#991014;}\r\n\t.st5{fill:none;stroke:#545051;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 355.6,
    y1: 164.4,
    x2: 355.6,
    y2: 156.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "355.6,108.7 355.6,81.9 278.2,4.5 75.7,4.5 5,81.9 4.5,238.9 355.6,238.9 355.6,211.1 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "355.6,81.9 132.9,81.9 75.7,4.5 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 132.9,
    y1: 81.9,
    x2: 132.9,
    y2: 238.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.2596e2be05ab04066c0ae0109ebbac8b.svg";
export { ForwardRef as ReactComponent };